import React, { Component } from 'react';
import {ABOUT, GETTING_STARTED, CONTACT, HELP} from './constants.js';

class LandingNavigator extends Component {
    render() {
        return (
            <div className="landing-navigator">
              <Option
                name="About"
                selectedOption={this.props.selectedOption}
                option={ABOUT}
                onClickOption={() => this.props.onClickOption(ABOUT)}>
              </Option>
              <Option
                name="Documentation"
                selectedOption={this.props.selectedOption}
                option={HELP}
                onClickOption={() => this.props.onClickOption(HELP)}>
              </Option>
              <Option
                name="Contact"
                selectedOption={this.props.selectedOption}
                option={CONTACT}
                onClickOption={() => this.props.onClickOption(CONTACT)}>
              </Option>
            </div>
        );
    }
}

class Option extends Component {
    render() {
        let className = "option";
        if (this.props.selectedOption === this.props.option) {
            className += ' selected';
        }

        return (
            <div onClick={() => this.props.onClickOption(this.props.option)}
              className={className}>
              {this.props.name}
            </div>
        );
    }
}

export default LandingNavigator;
